import React, {useState, useRef, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {useRouter} from 'next/router';

export default function History({aboutus}) {
    const {locale} = useRouter();

    const history = aboutus?.WEB_ABOUT_HISTORY?.value || {};
    const items = [...(history.array_items || [])].sort((a, b) => Number(a.num_index) - Number(b.num_index));

    const [hoveredItem, setHoveredItem] = useState(null);
    const [popupPosition, setPopupPosition] = useState({top: 0, left: 0});
    const refs = useRef({});
    const [index, setIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        const lastItem = document.querySelector('.history-item:last-child .history-text.bottom');
        const lastYear = document.querySelector('.history-item:last-child .history-year');
        if (lastItem && lastYear) {
            const textWidth = lastItem.offsetWidth;
            const yearRect = lastYear.getBoundingClientRect();
            const itemRect = lastItem.parentElement.getBoundingClientRect();
            const yearCenter = yearRect.left + yearRect.width / 2 - itemRect.left;
            lastItem.style.left = `${2 * (yearCenter - textWidth / 2)}px`;
            lastItem.style.transform = 'none';
        }
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const firstItem = document.querySelector('.history-item:first-child .history-text.top');
        const firstYear = document.querySelector('.history-item:first-child .history-year');

        if (firstItem && firstYear) {
            firstItem.style.left = `0`;
            firstItem.style.transform = 'none';
        }

        const lastItem = document.querySelector('.history-item:last-child .history-text.bottom');
        const lastYear = document.querySelector('.history-item:last-child .history-year');
        if (lastItem && lastYear) {
            const textWidth = lastItem.offsetWidth;
            const yearRect = lastYear.getBoundingClientRect();
            const itemRect = lastItem.parentElement.getBoundingClientRect();
            const yearCenter = yearRect.left + yearRect.width / 2 - itemRect.left;
            lastItem.style.left = `${2 * (yearCenter - textWidth / 2)}px`;
            lastItem.style.transform = 'none';
        }
    }, [history]);

    const handleMouseEnter = (item, year) => {
        const el = refs.current[year];
        const lastItemYear = items.length > 0 ? items[items.length - 1].year : null;
        if (el) {
            const rect = el.getBoundingClientRect();
            let leftPos = rect.right + window.scrollX - 100;
            let topPos = rect.top + window.scrollY - 100;

            if (year === lastItemYear) {
                leftPos = rect.right + window.scrollX - 640;
            }

            setPopupPosition({top: topPos, left: leftPos});
        }
        setHoveredItem(item);
    };

    const handleMouseLeave = () => setHoveredItem(null);

    const safeSplit = (text = '') => text.trim().split(/\s+/);

    const title = locale === 'en' ? history?.title_en : history?.title;
    const words = safeSplit(title);
    const firstTwo = words.slice(0, 2).join(' ');
    const rest = words.slice(2).join(' ');

    const subTitle = locale === 'en' ? history?.sub_title_en : history?.sub_title;
    const [firstWord = '', ...rest_sub] = safeSplit(subTitle);
    const rest_sub_Text = rest_sub.join(' ');

    return (
        <section className="history">
            <div className="history-header">
                <h2>
                    {firstTwo} <span>{rest}</span>
                </h2>
                <div className="history-subtitle">
                    <p>
                        <strong>{firstWord}</strong>
                    </p>
                    <p>{rest_sub_Text}</p>
                </div>
            </div>

            {isMobile ? (
                <div className="history-mobile">
                    <div className="history-mobile-image">
                        {items[index]?.image && /\.(png|jpe?g|gif|webp)$/i.test(items[index].image) ? (
                            <img src={items[index].image} alt={items[index].title_value || 'image'} />
                        ) : (
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGMAAQAABQABDQottAAAAABJRU5ErkJggg=="
                                alt="placeholder"
                                style={{backgroundColor: '#fff'}}
                            />
                        )}
                        <div className="history-mobile-overlay">
                            <p>{locale === 'en' ? items[index]?.description_en : items[index]?.description}</p>
                        </div>
                        <div className="overlay-mobile-overlay"></div>
                    </div>
                    <div className="history-mobile-year">{items[index]?.year}</div>
                    <div className="history-mobile-title">
                        {locale === 'en' ? items[index]?.title_value_en : items[index]?.title_value}
                    </div>
                    <div className="history-mobile-timeline">
                        {items.map((item, i) => (
                            <button
                                key={i}
                                type="button"
                                className={`timeline-dot ${i === index ? 'active' : ''}`}
                                aria-label={`${locale === 'en' ? 'View milestone' : 'Xem cột mốc'} ${item.year}`}
                                aria-pressed={i === index}
                                onClick={() => setIndex(i)}
                            />
                        ))}
                    </div>
                </div>
            ) : (
                <div className="history-timeline">
                    {items.map((item, index) => {
                        const position = index % 2 === 0 ? 'top' : 'bottom';
                        return (
                            <div
                                className="history-item"
                                key={item.num_index || index}
                                ref={el => (refs.current[item.year] = el)}
                                onMouseLeave={handleMouseLeave}>
                                {position === 'top' && (
                                    <div className="history-text top">
                                        {locale === 'en' ? item.title_value_en : item.title_value}
                                    </div>
                                )}
                                <div className="history-year" onMouseEnter={() => handleMouseEnter(item, item.year)}>
                                    {item.year}
                                </div>
                                {position === 'bottom' && (
                                    <div className="history-text bottom">
                                        {locale === 'en' ? item.title_value_en : item.title_value}
                                    </div>
                                )}
                                {hoveredItem?.year === item.year &&
                                    ReactDOM.createPortal(
                                        <div
                                            className="history-popup-global"
                                            style={{
                                                position: 'absolute',
                                                top: `${popupPosition.top}px`,
                                                left: `${popupPosition.left}px`,
                                            }}>
                                            <div className="history-popup-content">
                                                <img
                                                    onClick={handleMouseLeave}
                                                    className="history-popup-content-close"
                                                    src="/bw_image/ic_close.png"
                                                    alt="close"
                                                />
                                                <p style={{whiteSpace: 'pre-line'}}>
                                                    {locale === 'en' ? item.description_en : item.description}
                                                </p>
                                            </div>
                                            {item.image && /\.(png|jpe?g|gif|webp|svg)$/i.test(item.image) && (
                                                <img src={item.image} alt={item.title_value} />
                                            )}
                                        </div>,
                                        document.body,
                                    )}
                            </div>
                        );
                    })}
                </div>
            )}
        </section>
    );
}
